export default "__VITE_ASSET__CA1ntPQf__"